








































import { defineComponent, computed, PropType } from '@nuxtjs/composition-api';
import { useTranslations } from '@vue-storefront/novulo';

type Crumb = {
  link: string;
  text?: string;
  testId?: string;
};

export default defineComponent({
  name: 'ProductBreadcrumbs',
  props: {
    crumbs: { type: Array as PropType<Crumb[]>, default: () => [] },
    isPdp: { type: Boolean, default: false }
  },
  setup(props) {
    const { translate } = useTranslations();

    const validCrumbs = computed(() => props.crumbs.filter(c => c?.text));

    const mobileCalc = computed(() => {
      const items = validCrumbs.value;
      const n = items.length;

      const picked = new Set<number>();
      let lastText = '';

      for (let i = n - 1; i >= 0 && picked.size < 2; i--) {
        const c = items[i];
        if (!c?.link || c.link === '#') continue;

        const t = c.text || '';
        if (t && t === lastText) continue;

        picked.add(i);
        lastText = t;
      }

      const lastVisibleIndex = picked.size ? Math.max(...picked) : -1;
      return { picked, lastVisibleIndex };
    });

    const mobileLastIndex = computed(() => mobileCalc.value.lastVisibleIndex);

    const goBack = () => {
      if (process.client && window.history.length > 1) {
        window.history.back();
        return;
      }

      const items = validCrumbs.value;
      const picked = mobileCalc.value.picked;

      if (picked.size) {
        const firstVisible = Math.min(...picked);
        const target = items[firstVisible]?.link || '/';
        window.location.assign(target);
        return;
      }

      window.location.assign('/');
    };

    const backText = computed(() => translate?.('go_back') ?? 'Back');
    return {
      backText,
      mobileLastIndex,
      mobileCalc,
      validCrumbs,
      goBack,
      translate
    };

  }
});
